module.exports = __webpack_public_path__ + "img/jan-van-sundert.203aff86.svg";